import { createRoot } from 'react-dom/client';

import { DesignSystemProvider } from '@treezor/design-system';

import { Bootstrap } from '@/Bootstrap';
import { DashboardRoutes } from '@/router/components/DashboardRoutes';
import { useApplicationTheme } from '@/hooks/useApplicationTheme';
import { MatomoProvider } from '@/features/matomo/MatomoProvider';
import { QueryProvider } from '@/utils/queryClient';

import 'react-toastify/dist/ReactToastify.css';

import 'swiper/css';
import 'swiper/css/pagination';

import './i18n';

import './overrides';
import './index.css';
import { AwsRumErrorBoundary } from '@/features/awsRum/components/AwsRumErrorBoundary';
import { useInitAwsRum } from '@/features/awsRum/hooks/useInitAwsRum';
import { ErrorPage } from '@/pages/ErrorPage';

Object.typedKeys = Object.keys as any;
Object.typedEntries = Object.entries as any;

const Root = () => {
  const { appTheme } = useApplicationTheme();

  const awsRum = useInitAwsRum();

  return (
    <AwsRumErrorBoundary awsRum={awsRum} fallbackComponent={<ErrorPage />}>
      <MatomoProvider>
        <DesignSystemProvider theme={appTheme}>
          <DashboardRoutes />
        </DesignSystemProvider>
      </MatomoProvider>
    </AwsRumErrorBoundary>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <QueryProvider>
    <Bootstrap>
      <Root />
    </Bootstrap>
  </QueryProvider>,
);
